var calls;
(function (calls) {
    calls[calls["AddDispute"] = 0] = "AddDispute";
    calls[calls["AddDisputeResponse"] = 1] = "AddDisputeResponse";
    calls[calls["AddFixedPriceItem"] = 2] = "AddFixedPriceItem";
    calls[calls["AddItem"] = 3] = "AddItem";
    calls[calls["AddItemFromSellingManagerTemplate"] = 4] = "AddItemFromSellingManagerTemplate";
    calls[calls["AddItems"] = 5] = "AddItems";
    calls[calls["AddMemberMessageAAQToPartner"] = 6] = "AddMemberMessageAAQToPartner";
    calls[calls["AddMemberMessageRTQ"] = 7] = "AddMemberMessageRTQ";
    calls[calls["AddMemberMessagesAAQToBidder"] = 8] = "AddMemberMessagesAAQToBidder";
    calls[calls["AddOrder"] = 9] = "AddOrder";
    calls[calls["AddSecondChanceItem"] = 10] = "AddSecondChanceItem";
    calls[calls["AddSellingManagerInventoryFolder"] = 11] = "AddSellingManagerInventoryFolder";
    calls[calls["AddSellingManagerProduct"] = 12] = "AddSellingManagerProduct";
    calls[calls["AddSellingManagerTemplate"] = 13] = "AddSellingManagerTemplate";
    calls[calls["AddToItemDescription"] = 14] = "AddToItemDescription";
    calls[calls["AddToWatchList"] = 15] = "AddToWatchList";
    calls[calls["AddTransactionConfirmationItem"] = 16] = "AddTransactionConfirmationItem";
    calls[calls["CompleteSale"] = 17] = "CompleteSale";
    calls[calls["ConfirmIdentity"] = 18] = "ConfirmIdentity";
    calls[calls["DeleteMyMessages"] = 19] = "DeleteMyMessages";
    calls[calls["DeleteSellingManagerInventoryFolder"] = 20] = "DeleteSellingManagerInventoryFolder";
    calls[calls["DeleteSellingManagerItemAutomationRule"] = 21] = "DeleteSellingManagerItemAutomationRule";
    calls[calls["DeleteSellingManagerProduct"] = 22] = "DeleteSellingManagerProduct";
    calls[calls["DeleteSellingManagerTemplate"] = 23] = "DeleteSellingManagerTemplate";
    calls[calls["DeleteSellingManagerTemplateAutomationRule"] = 24] = "DeleteSellingManagerTemplateAutomationRule";
    calls[calls["DisableUnpaidItemAssistance"] = 25] = "DisableUnpaidItemAssistance";
    calls[calls["EndFixedPriceItem"] = 26] = "EndFixedPriceItem";
    calls[calls["EndItem"] = 27] = "EndItem";
    calls[calls["EndItems"] = 28] = "EndItems";
    calls[calls["ExtendSiteHostedPictures"] = 29] = "ExtendSiteHostedPictures";
    calls[calls["FetchToken"] = 30] = "FetchToken";
    calls[calls["GetAccount"] = 31] = "GetAccount";
    calls[calls["GetAdFormatLeads"] = 32] = "GetAdFormatLeads";
    calls[calls["GetAllBidders"] = 33] = "GetAllBidders";
    calls[calls["GetApiAccessRules"] = 34] = "GetApiAccessRules";
    calls[calls["GetBestOffers"] = 35] = "GetBestOffers";
    calls[calls["GetBidderList"] = 36] = "GetBidderList";
    calls[calls["GetCategories"] = 37] = "GetCategories";
    calls[calls["GetCategoryFeatures"] = 38] = "GetCategoryFeatures";
    calls[calls["GetCategoryMappings"] = 39] = "GetCategoryMappings";
    calls[calls["GetCategorySpecifics"] = 40] = "GetCategorySpecifics";
    calls[calls["GetChallengeToken"] = 41] = "GetChallengeToken";
    calls[calls["GetCharities"] = 42] = "GetCharities";
    calls[calls["GetClientAlertsAuthToken"] = 43] = "GetClientAlertsAuthToken";
    calls[calls["GetContextualKeywords"] = 44] = "GetContextualKeywords";
    calls[calls["GetDescriptionTemplates"] = 45] = "GetDescriptionTemplates";
    calls[calls["GetDispute"] = 46] = "GetDispute";
    calls[calls["GeteBayDetails"] = 47] = "GeteBayDetails";
    calls[calls["GeteBayOfficialTime"] = 48] = "GeteBayOfficialTime";
    calls[calls["GetFeedback"] = 49] = "GetFeedback";
    calls[calls["GetItem"] = 50] = "GetItem";
    calls[calls["GetItemsAwaitingFeedback"] = 51] = "GetItemsAwaitingFeedback";
    calls[calls["GetItemShipping"] = 52] = "GetItemShipping";
    calls[calls["GetItemTransactions"] = 53] = "GetItemTransactions";
    calls[calls["GetMemberMessages"] = 54] = "GetMemberMessages";
    calls[calls["GetMessagePreferences"] = 55] = "GetMessagePreferences";
    calls[calls["GetMyeBayBuying"] = 56] = "GetMyeBayBuying";
    calls[calls["GetMyeBayReminders"] = 57] = "GetMyeBayReminders";
    calls[calls["GetMyeBaySelling"] = 58] = "GetMyeBaySelling";
    calls[calls["GetMyMessages"] = 59] = "GetMyMessages";
    calls[calls["GetNotificationPreferences"] = 60] = "GetNotificationPreferences";
    calls[calls["GetNotificationsUsage"] = 61] = "GetNotificationsUsage";
    calls[calls["GetOrders"] = 62] = "GetOrders";
    calls[calls["GetOrderTransactions"] = 63] = "GetOrderTransactions";
    calls[calls["GetPromotionalSaleDetails"] = 64] = "GetPromotionalSaleDetails";
    calls[calls["GetSellerDashboard"] = 65] = "GetSellerDashboard";
    calls[calls["GetSellerEvents"] = 66] = "GetSellerEvents";
    calls[calls["GetSellerList"] = 67] = "GetSellerList";
    calls[calls["GetSellerTransactions"] = 68] = "GetSellerTransactions";
    calls[calls["GetSellingManagerAlerts"] = 69] = "GetSellingManagerAlerts";
    calls[calls["GetSellingManagerEmailLog"] = 70] = "GetSellingManagerEmailLog";
    calls[calls["GetSellingManagerInventory"] = 71] = "GetSellingManagerInventory";
    calls[calls["GetSellingManagerInventoryFolder"] = 72] = "GetSellingManagerInventoryFolder";
    calls[calls["GetSellingManagerItemAutomationRule"] = 73] = "GetSellingManagerItemAutomationRule";
    calls[calls["GetSellingManagerSaleRecord"] = 74] = "GetSellingManagerSaleRecord";
    calls[calls["GetSellingManagerSoldListings"] = 75] = "GetSellingManagerSoldListings";
    calls[calls["GetSellingManagerTemplateAutomationRule"] = 76] = "GetSellingManagerTemplateAutomationRule";
    calls[calls["GetSellingManagerTemplates"] = 77] = "GetSellingManagerTemplates";
    calls[calls["GetSessionID"] = 78] = "GetSessionID";
    calls[calls["GetShippingDiscountProfiles"] = 79] = "GetShippingDiscountProfiles";
    calls[calls["GetStore"] = 80] = "GetStore";
    calls[calls["GetStoreCategoryUpdateStatus"] = 81] = "GetStoreCategoryUpdateStatus";
    calls[calls["GetStoreCustomPage"] = 82] = "GetStoreCustomPage";
    calls[calls["GetStoreOptions"] = 83] = "GetStoreOptions";
    calls[calls["GetStorePreferences"] = 84] = "GetStorePreferences";
    calls[calls["GetSuggestedCategories"] = 85] = "GetSuggestedCategories";
    calls[calls["GetTaxTable"] = 86] = "GetTaxTable";
    calls[calls["GetTokenStatus"] = 87] = "GetTokenStatus";
    calls[calls["GetUser"] = 88] = "GetUser";
    calls[calls["GetUserContactDetails"] = 89] = "GetUserContactDetails";
    calls[calls["GetUserDisputes"] = 90] = "GetUserDisputes";
    calls[calls["GetUserPreferences"] = 91] = "GetUserPreferences";
    calls[calls["GetVeROReasonCodeDetails"] = 92] = "GetVeROReasonCodeDetails";
    calls[calls["GetVeROReportStatus"] = 93] = "GetVeROReportStatus";
    calls[calls["LeaveFeedback"] = 94] = "LeaveFeedback";
    calls[calls["MoveSellingManagerInventoryFolder"] = 95] = "MoveSellingManagerInventoryFolder";
    calls[calls["PlaceOffer"] = 96] = "PlaceOffer";
    calls[calls["RelistFixedPriceItem"] = 97] = "RelistFixedPriceItem";
    calls[calls["RelistItem"] = 98] = "RelistItem";
    calls[calls["RemoveFromWatchList"] = 99] = "RemoveFromWatchList";
    calls[calls["RespondToBestOffer"] = 100] = "RespondToBestOffer";
    calls[calls["RespondToFeedback"] = 101] = "RespondToFeedback";
    calls[calls["ReviseCheckoutStatus"] = 102] = "ReviseCheckoutStatus";
    calls[calls["ReviseFixedPriceItem"] = 103] = "ReviseFixedPriceItem";
    calls[calls["ReviseInventoryStatus"] = 104] = "ReviseInventoryStatus";
    calls[calls["ReviseItem"] = 105] = "ReviseItem";
    calls[calls["ReviseMyMessages"] = 106] = "ReviseMyMessages";
    calls[calls["ReviseMyMessagesFolders"] = 107] = "ReviseMyMessagesFolders";
    calls[calls["ReviseSellingManagerInventoryFolder"] = 108] = "ReviseSellingManagerInventoryFolder";
    calls[calls["ReviseSellingManagerProduct"] = 109] = "ReviseSellingManagerProduct";
    calls[calls["ReviseSellingManagerSaleRecord"] = 110] = "ReviseSellingManagerSaleRecord";
    calls[calls["ReviseSellingManagerTemplate"] = 111] = "ReviseSellingManagerTemplate";
    calls[calls["RevokeToken"] = 112] = "RevokeToken";
    calls[calls["SaveItemToSellingManagerTemplate"] = 113] = "SaveItemToSellingManagerTemplate";
    calls[calls["SellerReverseDispute"] = 114] = "SellerReverseDispute";
    calls[calls["SendInvoice"] = 115] = "SendInvoice";
    calls[calls["SetMessagePreferences"] = 116] = "SetMessagePreferences";
    calls[calls["SetNotificationPreferences"] = 117] = "SetNotificationPreferences";
    calls[calls["SetPromotionalSale"] = 118] = "SetPromotionalSale";
    calls[calls["SetPromotionalSaleListings"] = 119] = "SetPromotionalSaleListings";
    calls[calls["SetSellingManagerFeedbackOptions"] = 120] = "SetSellingManagerFeedbackOptions";
    calls[calls["SetSellingManagerItemAutomationRule"] = 121] = "SetSellingManagerItemAutomationRule";
    calls[calls["SetSellingManagerTemplateAutomationRule"] = 122] = "SetSellingManagerTemplateAutomationRule";
    calls[calls["SetShippingDiscountProfiles"] = 123] = "SetShippingDiscountProfiles";
    calls[calls["SetStore"] = 124] = "SetStore";
    calls[calls["SetStoreCategories"] = 125] = "SetStoreCategories";
    calls[calls["SetStoreCustomPage"] = 126] = "SetStoreCustomPage";
    calls[calls["SetStorePreferences"] = 127] = "SetStorePreferences";
    calls[calls["SetTaxTable"] = 128] = "SetTaxTable";
    calls[calls["SetUserNotes"] = 129] = "SetUserNotes";
    calls[calls["SetUserPreferences"] = 130] = "SetUserPreferences";
    calls[calls["UploadSiteHostedPictures"] = 131] = "UploadSiteHostedPictures";
    calls[calls["ValidateChallengeInput"] = 132] = "ValidateChallengeInput";
    calls[calls["ValidateTestUserRegistration"] = 133] = "ValidateTestUserRegistration";
    calls[calls["VerifyAddFixedPriceItem"] = 134] = "VerifyAddFixedPriceItem";
    calls[calls["VerifyAddItem"] = 135] = "VerifyAddItem";
    calls[calls["VerifyAddSecondChanceItem"] = 136] = "VerifyAddSecondChanceItem";
    calls[calls["VerifyRelistItem"] = 137] = "VerifyRelistItem";
    calls[calls["VeROReportItems"] = 138] = "VeROReportItems";
})(calls || (calls = {}));
export default calls;
